import DrawerMenu from "@mui/icons-material/Menu";
import VideoCallOutlinedIcon from "@mui/icons-material/VideoCallOutlined";
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import ArrowDown from "../../SVGs/ArrowDown";
import MenuIcon from "../../SVGs/MenuIcon";
import SearchIcon from "../../SVGs/SearchIcon";
import { CustomDrawer } from "../CustomDrawer/index";
import UserAvatar from "../UserAvatar";
import AuthMenu from "./AuthMenu";

function Header({ handleDrawerToggle }) {
  const nav = useNavigate();

  const [menuEl, setMenuEL] = useState(null);
  const [navScrolled, setNavScrolled] = useState(false);

  const isAuthenticated = useSelector((s) => s.auth.isAuthenticated);
  const user = useSelector((s) => s.auth.user);

  const openMenu = (event) => {
    setMenuEL(event.currentTarget);
  };
  const closeMenu = () => {
    setMenuEL(null);
  };

  const onScroll = useCallback(() => {
    if (window.scrollY > 50 && !navScrolled && setNavScrolled) {
      setNavScrolled(true);
    } else if (window.scrollY < 50 && navScrolled && setNavScrolled) {
      setNavScrolled(false);
    }
  }, [navScrolled, setNavScrolled]);

  useEffect(() => {
    onScroll();
    window.addEventListener("scroll", onScroll);
  });

  return (
    <>
      <AuthMenu user={user} anchorEl={menuEl} handleClose={closeMenu} />
      <AppBar position="fixed">
        <Toolbar
          sx={{
            bgcolor: "background.black",
            position: "sticky",
            top: 0,
            boxShadow: "0px 7px 15px #32323229",
            color: "text.secondary",
          }}
        >
          <CustomDrawer
            btnSx={{ m: { xs: 1, sm: 2 }, color: "#fff" }}
            color="#000"
            navScrolled={navScrolled}
          >
            <Container maxWidth="xl" sx={{ width: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  width: 1,
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  alignItems: { xs: "flex-start", lg: "center" },
                  flexDirection: { xs: "column", lg: "row" },
                }}
              >
                <Box component={Link} to="/">
                  <img src="/images/layout/logo.png" alt="" />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap",
                    py: { xs: 1 },
                  }}
                >
                  <IconButton
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{
                      display: { sm: "none" },
                      color: "#C8C8C8",
                      "&:hover": {
                        color: "#25AAE1",
                      },
                    }}
                  >
                    <DrawerMenu />
                  </IconButton>
                  <IconButton
                    sx={{
                      transition: "0.5s all",
                      cursor: "pointer",
                      fill: "#C8C8C8",
                      "&:hover": {
                        fill: "#25AAE1",
                        backgroundColor: "transparent",
                      },
                    }}
                  >
                    <ArrowDown />
                  </IconButton>

                  <IconButton
                    sx={{
                      transition: "0.5s all",
                      fill: "#C8C8C8",
                      stroke: "#C8C8C8",
                      "&:hover": {
                        fill: "#25AAE1",
                        stroke: "#25AAE1",
                        backgroundColor: "transparent",
                      },
                    }}
                  >
                    <SearchIcon />
                    <MenuIcon />
                  </IconButton>
                  <TextField
                    placeholder="Search for any things: Event, Short Films..."
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    size="small"
                    sx={{
                      maxWidth: { xs: "100px" },
                      display: { md: "block" },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderWidth: 0,
                        },
                      },
                      input: {
                        color: "red",
                        "&::placeholder": {
                          color: "text.secondary",
                        },
                      },
                    }}
                  />
                </Box>
                {isAuthenticated ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: { xs: "0.5em", sm: "1em" },
                      flexWrap: "wrap",
                    }}
                  >
                    {/* <IconButton sx={{ transition: "0.5s all", fill: "#fff" }}>
                    <NotificationBell />
                  </IconButton> */}
                    <Button
                      variant="contained"
                      sx={{
                        minWidth: "unset",
                        width: "40px",
                        height: "40px",
                        boxShadow: "0px 3px 20px #856415",
                      }}
                      onClick={() => nav("/create-video")}
                    >
                      <VideoCallOutlinedIcon />
                    </Button>
                    <UserAvatar
                      src={user?.image}
                      alt={user?.firstName + user?.lastName || user?.username}
                      color={user?.color}
                      type={"user"}
                      sx={{
                        width: { xs: "30px", sm: "50px" },
                        height: { xs: "30px", sm: "50px" },
                      }}
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        color: "text.white",
                        pointerEvents: "none",
                      }}
                    >
                      {user?.firstName + user?.lastName || user?.username}
                    </Typography>
                    <IconButton
                      sx={{
                        fill: "#fff",
                        transition: "0.5s all",
                      }}
                      onClick={openMenu}
                    >
                      <ArrowDown />
                    </IconButton>
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Button
                      variant="contained"
                      onClick={() => nav("/login")}
                      sx={{ mr: 2 }}
                    >
                      Login
                    </Button>
                    <Button variant="outlined" onClick={() => nav("/register")}>
                      Register
                    </Button>
                  </Box>
                )}
              </Box>
            </Container>
          </CustomDrawer>
        </Toolbar>
      </AppBar>
      <Box sx={{ width: 1, height: "70px" }} />
    </>
  );
}

export default Header;
